import React, { useEffect } from "react";
import simbarang from "../assets/images/simbarang.png";
import simaset from "../assets/images/simaset.png";
import AOS from "aos";
import "aos/dist/aos.css";

const projectLists = [
  {
    src: simbarang,
    name: "SIMBARANG",
    px: "px-5",
  },
  {
    src: simaset,
    name: "SIMASET",
    px: "px-6",
  },
];

const Projects = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const renderedProject = projectLists.map(({ src, name, px }) => {
    return (
      <div key={name} className="flex flex-col items-center mb-1">
        <div className="flex flex-col items-center">
          <img
            src={src}
            alt={name}
            className="p-8 w-4/5 xl:w-11/12 rounded-sm"
            style={{ backgroundColor: "#FFC837" }}
          />
          <button
            className={`text-white font-semibold xl:w-1/3 lg:w-1/2 w-2/5 text-sm my-2 ${px} py-2 rounded shadow`}
            style={{ backgroundImage: "linear-gradient(#D31027, #EA384D)" }}
          >
            {name}
          </button>
        </div>
      </div>
    );
  });

  return (
    <div
      className="flex flex-col lg:flex-row lg:mt-5 lg:flex-wrap lg:justify-center items-center md:mt-8 pb-3 font-montserrat"
      data-aos="fade-right"
    >
      <div className="flex flex-col items-center">
        <h3 className="mb-5 font-semibold text-2xl">Latest Project</h3>
        <div className="lg:flex-row md:flex-row md:flex lg:flex lg:w-full xl:w-8/12">
          {renderedProject}
        </div>
      </div>
    </div>
  );
};

export default Projects;
